import { FC } from "react";
import { Alert } from "shared/components/Spor";

export const GlobalEventTempFixText: FC = () => (
  <Alert data-color="warning" width="100%" fontSize="16px" m={2}>
    Muligheten til å opprette globale meldinger fremover i tid er midlertidlig
    skrudd av mens vi venter på en fiks hos vy.no
  </Alert>
);
